import { Injectable, EventEmitter } from '@angular/core';
import { Http, Headers } from '@angular/http';
import * as Entities from '../data/Entities';

import 'rxjs/add/operator/toPromise';
import { BehaviorSubject } from 'rxjs';

declare var appConfig: any;
declare var jQuery: any;

@Injectable()
export class EnvironmentServices {
    public onChangeDetail = new BehaviorSubject(null);

    constructor() {}

    public getSiteImagesUrl(): string {
        if (
            window.location.href.indexOf('https://at-weshopapp-roksh-admin.') >
                -1 ||
            window.location.href.indexOf('https://admin.roksh.at') > -1
        ) {
            return 'https://atweshopsiteimages.azureedge.net';
        } else if (
            window.location.href.indexOf(
                'https://weshopapp-roksh-admin.azurewebsites.'
            ) > -1 ||
            window.location.href.indexOf('https://admin.roksh.com.') > -1
        ) {
            return 'https://weshopsiteimages.azureedge.net';
        } else if (
            window.location.href.indexOf('admin-master.roksh.at') > -1 ||
            window.location.href.indexOf('admin-staging.roksh.at') > -1
        ) {
            return 'https://atweshopsiteimagesmaster.azureedge.net';
        } else if (window.location.href.indexOf('admin-b2b.roksh.com') > -1) {
            return 'https://weshopsiteimagesb2b.blob.core.windows.net';
        } else {
            return 'https://weshopsiteimagesmaster.azureedge.net';

        }
    }

    public getRokshSiteUrl(): string {
        if (
            window.location.href.indexOf('https://at-weshopapp-roksh-admin.') >
            -1 ||
            window.location.href.indexOf('https://admin.roksh.at') > -1
        ) {
            return 'https://roksh.at';
        } else if (
            window.location.href.indexOf(
                'https://weshopapp-roksh-admin.azurewebsites.'
            ) > -1 ||
            window.location.href.indexOf('https://admin.roksh.com.') > -1
        ) {
            return 'https://roksh.com';
        } else if (
            window.location.href.indexOf('admin-master.roksh.at') > -1 ||
            window.location.href.indexOf('admin-staging.roksh.at') > -1
        ) {
            return 'https://staging.roksh.at';
        } else if (window.location.href.indexOf('admin-b2b.roksh.com') > -1) {
            return 'https://b2b.roksh.com';
        } else {
            return 'https://staging.roksh.com';
        }
    }

    //https://shopservice-staging.roksh.com/mobileApplicationSettings/frontendVersionNumber/FrontendVersionNumberDesktopStaging
    public getRokshShopserviceUrl(): string {
        if (
            window.location.href.indexOf('https://at-weshopapp-roksh-admin.') >
            -1 ||
            window.location.href.indexOf('https://admin.roksh.at') > -1
        ) {
            return 'https://shopservice.roksh.at';
        } else if (
            window.location.href.indexOf(
                'https://weshopapp-roksh-admin.azurewebsites.'
            ) > -1 ||
            window.location.href.indexOf('https://admin.roksh.com.') > -1
        ) {
            return 'https://shopservice.roksh.com';
        } else if (
            window.location.href.indexOf('admin-master.roksh.at') > -1 ||
            window.location.href.indexOf('admin-staging.roksh.at') > -1
        ) {
            return 'https://shopservice-staging.roksh.at';
        } else {
            return 'https://shopservice-staging.roksh.com';
        }
    }

}
